<template>
    <div>
        <div 
        style="padding: 4px;
        font-size: 10px;
        font-weight: 400;
        background: rgba(224, 224, 224, 0.137);
        color: rgb(80 78 78);
        border: 1px solid rgb(149 149 149);
        border-radius: 6px;
        margin: 6px;">
        <b>Mail Box</b> {{ getProfile}} 
         <v-icon @click="showDetails=!showDetails"  size="18px" class="pl-3 mdi mdi-information" style="cursor: pointer;" /><br/>
        <span v-if="showDetails"><b>Conversation #</b> {{ getMailConversationId }}<br/>
        <b>Item id #</b> {{ getMailItemId }}<br/>
        <b>Rest #</b> {{ getMailRestId }}<br/></span>
</div>

        <DefaultSelection v-if="defaultSelection != 'none' && !showMessage" :defaultSelection="defaultSelection" 
            @itemSelected="itemSelected" @changeDefaulValue="changeDefaulValue" :registerAccountData="registerAccountData" />
        <Stepper v-if="defaultSelection == 'none' && !showMessage" @output="setMessage" />
        <Message v-if="showMessage" :message="messageData" :data="issueData" />
    </div>
</template>
<script>
/* eslint-disable no-undef */
import DefaultSelection from './DefaultSelection.vue'
import Stepper from "@/components/Stepper.vue"
import Message from "@/components/Message.vue"
import BaseService from "@/api/service/BaseService";
import moment from 'moment'
export default {
    props: ["refreshData"],
    components: {
        DefaultSelection,
        Stepper,
        Message
    },
    data() {
        return {
            showDetails:false,
            profileUpdate:false,
            defaultSelection: null,
            messageData: null,
            showMessage: false,
            issueData: null,
            defaultData:null,
            accountByEmailData:null,
            registerAccountData:[]

        }
    },
    // async created() {
    //     await this.getMessageId();
    //     this.defaultSelection = "workspaces",
    //     this.isOkToCreate()
    // },
    computed:{
        
        getMailItemId() {
            return Office.context.mailbox.item.itemId
        },
        getMailConversationId() {
            return Office.context.mailbox.item.conversationId
        },
        getMailRestId() {
            // Convert to an item ID for API v2.0.
            return Office.context.mailbox.convertToRestId(
                Office.context.mailbox.item.itemId,
                Office.MailboxEnums.RestVersion.v2_0
            );
        },
        getProfile() {
            return Office.context.mailbox.userProfile.emailAddress
        }
    },
    watch: {
        async getProfile() {
            await this.getAccountByEmail()  
        },
        refreshData() {
            if (this.refreshData) {
                console.log(this.defaultSelection,"start referefedferewwe")
                this.isOkToCreate()
                console.log(this.defaultSelection,"start referefedferewwe")
                this.$emit('refreshed')
            }
        }

    },
    mounted() {

    },
    async updated() {
       

    },
    async created(){  
            this.defaultSelection = "workspaces"
            this.defaultData = JSON.parse(localStorage.getItem("_WS_DEFAULTS_"))
            await this.getMessageId();
            await this.getAccountByEmail()  
            this.isOkToCreate(true)
    },
    methods: {
        moment,
        changeDefaulValue(){
            console.log("changeDefaulValueeeeeeeeeeeee");
            this.$emit('reload',true)

        },
        async getAccountByEmail(){
         try{
            // console.log(Office.context.mailbox.userProfile,"getting email data")
            let res = await BaseService.getAccountByEmail({email:Office.context.mailbox.userProfile.emailAddress})
            this.registerAccountData =res && res.length>0?res:[]
            console.log(this.registerAccountData,"registerAccountData")
            if(this.registerAccountData && this.registerAccountData.length==1 && this.defaultData && this.defaultData.account && this.defaultData.account.id ==this.registerAccountData[0].id){
                console.log("same account")
            }
            else if(this.registerAccountData && this.registerAccountData.length>0){
                    console.log(this.defaultData,"defaultData")                    
                    delete this.defaultData.account 
                    delete this.defaultData.project
                    delete this.defaultData.taskgroup
                    this.defaultSelection = 'account'
                    localStorage.setItem('_WS_DEFAULTS_', JSON.stringify(this.defaultData?this.defaultData:{}))
                    this.$emit('reload',true)
            }
         }
         catch(e){
            this.accountByEmailData =null
            console.log(e)
         }
        },
        /*async getAccountByEmail(){
         try{
            this.profileUpdate=true
            console.log(Office.context.mailbox.userProfile,"getting email data")
            let res = await BaseService.getAccountByEmail({email:Office.context.mailbox.userProfile.emailAddress})
            this.accountByEmailData =res && res.length>0?res:null
            console.log(this.accountByEmailData,"getting email data")
            if(this.accountByEmailData && this.accountByEmailData.length>0){     
                console.log(Office.context.mailbox.userProfile,"getting email data")   
                    delete this.defaultData.account
                    delete this.defaultData.project
                    localStorage.setItem('_WS_DEFAULTS_', JSON.stringify(this.defaultData))
                    this.defaultSelection='account'
                    console.log("hello userssssss i am bala checking")                    
                    this.isOkToCreate()
                    this.$emit('refreshed')
                    // this.itemSelected(obj)
            }
            this.profileUpdate=false
         }
         catch(e){
            this.accountByEmailData =null
            console.log(e)
         }
        },
        */

        itemSelected($item,type) {
            console.log($item,"getting the chan",this.defaultSelection,type)
            let $wsDefaults = localStorage.getItem("_WS_DEFAULTS_")
            // console.log($item,'wsDefaults')
            if ($wsDefaults) {
                $wsDefaults = JSON.parse($wsDefaults)
            } else {
                $wsDefaults = {}
            }
            if(this.defaultSelection =='workspaces' && type =='workspaces'){
                    $wsDefaults.workspace = $item;
            }
            else if(this.defaultSelection =='account' && type =='account'){
                    $wsDefaults.account = $item;                
            }
            else if(this.defaultSelection =='project' && type =='project'){
                    $wsDefaults.project = $item;                
            }
            else if(this.defaultSelection =='taskgroup' && type =='taskgroup'){
                    $wsDefaults.taskgroup = $item;                
            }
            // switch (this.defaultSelection) {
            //     case 'workspaces':
            //         $wsDefaults.workspace = $item;
            //         break;
            //     case 'account':
            //         $wsDefaults.account = $item;
            //         break;
            //     case 'project':
            //         $wsDefaults.project = $item;
            //         break;
            //     case 'taskgroup':
            //         $wsDefaults.taskgroup = $item;
            //         break;    
            // }
            localStorage.setItem('_WS_DEFAULTS_', JSON.stringify($wsDefaults))
            this.$emit("reload", true)
            this.isOkToCreate()
        },
        setMessage($event) {
            this.showMessage = true
            this.messageData = $event
            this.getMessageId($event)
            this.$emit("created", true)
        },
        async getMessageId($msg) {
            // eslint-disable-next-line no-undef
            
            let issueData 
            const item = Office.context.mailbox.item;            
            const mail_box =Office.context.mailbox.userProfile.emailAddress
            issueData = await BaseService.checkOutlookMailBox({ mail_box_id: item.itemId,active:1,mail_box:mail_box });
            this.issueData = issueData[0]

            if (issueData.length > 0) {
                this.messageData = $msg?$msg:'Issue Already Created'
                this.showMessage = true
                this.$emit("created", true)
            }
            else {
                this.showMessage = false
            }
        },
        isOkToCreate(flag) {
            let $wsDefaults = localStorage.getItem("_WS_DEFAULTS_")
            console.log($wsDefaults,"ooooooooooooe")
            if ($wsDefaults) {
                $wsDefaults = JSON.parse($wsDefaults)
                if (!$wsDefaults.workspace) {
                    this.defaultSelection = 'workspaces'
                }
                else if (!$wsDefaults.account) {
                    this.defaultSelection = 'account'
                }
                else if (!$wsDefaults.project) {
                    this.defaultSelection = 'project'
                }
                else if (!$wsDefaults.taskgroup || flag) {
                    this.defaultSelection = 'taskgroup'
                }
                else {
                    this.defaultSelection = 'none'
                }
            } else {
                this.defaultSelection = 'workspaces'
                return
            }
        }
    }
}

</script>

